import React from "react";
import { LazyLoadImage, LinkButton } from "../../../../../core/atoms";
import "./aboutTeam.scss";

interface Props {
  title: string;
  content: string;
  linkText: string;
  linkUrl: string;
}

export const AboutTeam: React.FC<Props> = ({
  title,
  content,
  linkText,
  linkUrl,
}) => {
  const backgroundImage: ISrcSet = {
    default: "https://resources.travellocal.com/about-us/about-us-team-2020_large.jpg",
    srcs: [
      {
        src: "https://resources.travellocal.com/about-us/about-us-team-2020_small.jpg",
        width: 512,
      },
      {
        src: "https://resources.travellocal.com/about-us/about-us-team-2020_medium.jpg",
        width: 960,
      },
      {
        src: "https://resources.travellocal.com/about-us/about-us-team-2020_large.jpg",
        width: 1800,
      },
    ],
  };

  const sharedColumnClass = "column is-8-tablet is-offset-4-tablet is-9-desktop is-offset-3-desktop is-12-fullhd about-team__column";

  return (
    <div className="about-team">
      <LazyLoadImage src={backgroundImage} className="about-team__image" alt="These are some of the people who make up our team at Travellocal HQ" />
      <div className="about-team__wrapper width-wrapper width-wrapper--desktop">
        <div className="columns">
          <div className={sharedColumnClass}>
            <div className="about-team__content">
              <h2 className="about-team__title">{title}</h2>
              <p>{content}</p>
              <LinkButton to={linkUrl} className="primary-button heading--4 text--light">{linkText}</LinkButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
